export default __webpack_public_path__ + "static/media/amex.d5cdcaee.svg";